import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'dateShortExtra'
})
export class DateShortExtraPipe implements PipeTransform {
  transform(value: Date | string): string | null {
    const date = new Date(value);
    const locale = localStorage.getItem("lang") || navigator.language || 'en-US';
    const formatter = new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: 'short',
      year: '2-digit'
    });

    return formatter.format(date);
  }
}
